// extracted by mini-css-extract-plugin
export default {"tabletImg":"zC","desktopImg":"AC","mobileImg":"BC","backgroundImage":"CC","content":"EC","rtbLeft":"FC","rtbRight":"GC","imageContainer":"HC","rtbBox":"IC","line":"JC"};
    if(module.hot) {
      // 1713996747420
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  